<template>
  <div class="row">
    <div class="col-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateAudit"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillAuditForm="fillAuditForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.sub_category_and_tasks')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillAuditForm="fillAuditForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ auditForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.description') }}:</strong>
                        </h6>
                        {{ auditForm.description }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.type') }}:</strong>
                        </h6>
                        {{ auditForm.type }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.type_of_grade') }}:</strong
                          >
                        </h6>
                        {{ auditForm.type_calification }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.type_capture') }}:</strong
                          >
                        </h6>
                        <el-tag type="info">{{
                          auditForm.audit_type_label
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{
                            $t('common_words.associated_companies')
                          }}</strong>
                        </h6>
                        <span
                          v-for="(business, index) in auditForm.business_name"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{
                            $t('common_words.associated_profiles2')
                          }}</strong>
                        </h6>
                        <span
                          v-for="(role, index) in auditForm.roles_name"
                          :key="index"
                        >
                          <el-tag type="info">{{ role }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{
                            $t('common_words.associated_users2')
                          }}</strong>
                        </h6>
                        <span
                          v-for="(user, index) in auditForm.users_name"
                          :key="index"
                        >
                          <el-tag type="info">{{ user }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.sub_associated_category')
                            }}:</strong
                          >
                        </h6>
                        <table
                          aria-describedby="tabla-subcategoria"
                          v-if="auditForm.sub_category_names.length > 0"
                          style="width: 100%"
                        >
                          <thead>
                            <tr>
                              <th>
                                {{ $t('common_words.sub_category_mayus') }}
                              </th>
                              <th>{{ $t('common_words.mayus_tasks') }}</th>
                              <th>
                                {{ $t('common_words.required_questionmark') }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <template>
                              <tr
                                v-for="(index, order) in orderData(
                                  auditForm.subcategoryOrder
                                )"
                                :key="order"
                              >
                                <td>
                                  <el-tag
                                    type="info"
                                    v-if="auditForm.sub_category_names[index]"
                                  >
                                    <span
                                      v-tooltip.top-center="
                                        auditForm.sub_category_names[index]
                                          .length > 45
                                      "
                                    >
                                      {{ order }} -
                                      {{
                                        auditForm.sub_category_names[
                                          index
                                        ].substring(0, 45)
                                      }}{{
                                        auditForm.sub_category_names[index]
                                          .length > 45
                                          ? `...`
                                          : ``
                                      }}
                                    </span>
                                  </el-tag>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, j) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      :key="j"
                                      v-if="auditForm.task_names[taskIndex]"
                                      class="mb-2"
                                    >
                                      <el-tag type="warning" size="medium">
                                        <span
                                          v-tooltip.top-center="
                                            auditForm.task_names[taskIndex]
                                              .length > 45
                                              ? `${j} - ${auditForm.task_names[taskIndex]}`
                                              : ``
                                          "
                                        >
                                          {{ j }} -
                                          {{
                                            auditForm.task_names[
                                              taskIndex
                                            ].substring(0, 45)
                                          }}{{
                                            auditForm.task_names[taskIndex]
                                              .length > 45
                                              ? `...`
                                              : ``
                                          }}
                                        </span>
                                      </el-tag>
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, j) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="
                                        auditForm.is_required[taskIndex] !==
                                        undefined
                                      "
                                      :key="j"
                                      class="mb-2"
                                    >
                                      <el-tag
                                        type="warning"
                                        size="medium"
                                        style="width: 40px"
                                      >
                                        {{
                                          auditForm.is_required[taskIndex]
                                            ? 'Si'
                                            : 'No'
                                        }}
                                      </el-tag>
                                    </p>
                                  </template>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                        <el-tag
                          type="warning"
                          v-if="auditForm.sub_category_names.length == 0"
                          >{{
                            $t('common_words.no_sub_associated_category')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import { showContinue } from 'src/util/Util.js';

export default {
  components: {
    FirstStep,
    SecondStep,
  },

  data() {
    return {
      title: '',
      auditForm: {
        name: null,
        description: null,
        catch_type: null,
        calification_type: null,
        audit_type: 'web',
        business_name: null,
        sub_category_ids: [],
        subcategoryOrder: [],
        sub_category_names: [],
        task_ids: [],
        task_order: [],
        task_names: [],
      },
      wizardModel: {},
    };
  },
  mixins: [MixinPermissions, mixinMasters, MixinMenu],
  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        name: null,
        description: null,
        catch_type: null,
        calification_type: null,
        business_id: null,
        audit_type: 'web',
        roles_id: [],
        users_id: [],
        businesses_id: [],
      };
      this.$refs.secondStep.model = {
        sub_category_names: [],
        subcategoryOrder: [],
        sub_category_ids: [],
        tasks_number: [],
        task_ids: {},
        task_order: {},
        task_names: {},
        is_required: {},
      };
      this.auditForm = {
        name: null,
        description: null,
        catch_type: null,
        calification_type: null,
        business_name: null,
        sub_category_ids: [],
        subcategoryOrder: [],
        sub_category_names: [],
        task_ids: [],
        task_order: [],
        task_names: [],
      };
    },

    orderData(data) {
      let array = [];
      try {
        array = Object.entries(data);
      } catch (error) {
        //
      }

      array.sort((a, b) => a[1] - b[1]);
      const sortedObj = Object.fromEntries(
        array.map(([value, key]) => [key, value])
      );

      return sortedObj;
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    getOrderTask(indexSubcategory) {
      let a = 0;
      const response = [];
      while (a < this.auditForm.tasks_number[indexSubcategory]) {
        response.push(`${indexSubcategory}${a}`);
        a++;
      }

      response.sort((a, b) => a - b);

      const array = Object.entries(this.auditForm.task_order);
      const orderTask = {};
      array.forEach((data) => {
        if (response.includes(data[0])) {
          orderTask[data[0]] = data[1];
        }
      });

      return orderTask;
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillAuditForm(ref, others) {
      this.auditForm = Object.assign({}, this.auditForm, this.$refs[ref].model);

      if (others) this.auditForm = Object.assign({}, this.auditForm, others);
    },

    storeUpdateAudit() {
      this.showHideLoading(true);
      this.auditForm.route = 'audits/audits';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.auditForm.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.auditForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/audits/audits',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.auditForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/audits/audits',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('audits');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('audits');
  },
};
</script>
<style></style>
